import gql from 'graphql-tag';

export default gql`
  mutation AddUserMeal($input: DailyTrackerAddUserMealInputType!) {
    dailyTracker {
      addUserMeal(input: $input) {
        ... on DailyTrackerAddUserMealSuccess {
          meal {
            id
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
